import React from 'react';
import KitchenLayoutViewer from '@/utils/roomDrawingFunctions';
import WallElevations from '@/utils/WallElevations';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export const LayoutSection = ({ projectData, onEdit, isEditable }) => (
  <Card className="mb-4">
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle className="text-xl font-bold">Layout & Dimensions</CardTitle>
      {isEditable && (
        <Button variant="outline" size="sm" onClick={() => onEdit("layout")}>
          Edit
        </Button>
      )}
    </CardHeader>
    <CardContent>
      <div className="space-y-6">
        {/* Floor Plan View */}
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">Floor Plan</h3>
          {projectData?.floorPlan && projectData?.kitchenLayout && (
            <KitchenLayoutViewer 
              floorPlanData={projectData.floorPlan}
              kitchenLayout={projectData.kitchenLayout || []}
            />
          )}
        </div>

        <Separator className="my-4" />

        {/* Wall Elevations */}
        <div className="space-y-2">
          <h3 className="text-lg font-semibold">Wall Elevations</h3>
          {projectData?.floorPlan && (
            console.log('LayoutSection - Floor Plan Data:', projectData.floorPlan) ||
            <WallElevations 
              floorPlanData={projectData.floorPlan}
              containerHeight={400}
            />
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default LayoutSection;